import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "convex/react";
import { api } from "@convex/_generated/api";
import { useAdminAuth } from "@/features/admin/hooks/useAdminAuth";
import { AdminShell } from "@/features/admin/shell/AdminShell";
import { AdminPageHeader } from "@/features/admin/shell/AdminPageHeader";
import { TeamsTable } from "@/features/admin/teams/components/TeamsTable";
import { PrintRosterButton } from "@/features/admin/teams/components/PrintRosterButton";
import { Skeleton } from "@/shared/ui/Skeleton";
import { useT } from "@/shared/i18n/LocaleContext";

export const Route = createFileRoute("/_adminGuarded/admin/")({
  component: AdminTeamsPage,
});

function AdminTeamsPage() {
  const t = useT();
  const { state } = useAdminAuth();
  const token = state.status === "authenticated" ? state.token : null;
  const rows = useQuery(api.admin.listTeams, token ? { token } : "skip");

  return (
    <AdminShell breadcrumbs={[{ label: t("admin.teams.title") }]}>
      <AdminPageHeader
        title={t("admin.teams.title")}
        subtitle={t("admin.teams.subtitle")}
        actions={token ? <PrintRosterButton token={token} /> : null}
      />

      {rows === undefined ? (
        <div className="flex flex-col gap-2">
          <Skeleton className="h-12 w-full" />
          <Skeleton className="h-12 w-full" />
          <Skeleton className="h-12 w-full" />
        </div>
      ) : (
        <TeamsTable rows={rows} />
      )}
    </AdminShell>
  );
}
